module.exports = __webpack_public_path__ + "eric-8d222630793cc52106a6e027766afdd7.webp";